// TODO: Add test
export function isConditionalParam(param) {
    return !!param && param.hasOwnProperty('securityThreshold');
}
//# sourceMappingURL=isConditionalParam.js.map